/**
 * Function to show the details of the event
 *
 * @param calEvent the calendar event with the data
 *
 * @return void
 */
export function showEventDetails(calEvent) {
    // Convert to ints
    calEvent.start = parseInt(calEvent.start);
    calEvent.end = parseInt(calEvent.end);

    // Ensure that resources, tutors, locations and outcomes all default to an empty array
    // This is so that we can use nice, clean, readable code later on...
    calEvent.resources       = calEvent.resources ? _.values(calEvent.resources) : [];
    calEvent.tutors          = calEvent.tutors ? _.values(calEvent.tutors) : [];
    calEvent.locations       = calEvent.locations ? _.values(calEvent.locations) : [];
    calEvent.outcomes.tomdoc = calEvent.outcomes.tomdoc ? _.values(calEvent.outcomes.tomdoc) : [];
    calEvent.outcomes.local  = calEvent.outcomes.local ? _.values(calEvent.outcomes.local) : [];

    // Grab the data for the location & lecturers
    var locations         = '';
    var overflow_location = '';
    var lecturers         = '';
    var tags              = '';

    // Populate the data
    $('#modal-event-title').html(calEvent.title);

    // Locations
    if (calEvent.locations && calEvent.locations.length > 0) {
        $.each(calEvent.locations, function (idx, location) {
            var location_title = [
                location.room,
                location.building,
                location.address1,
                location.address2,
                location.town,
                location.postcode,
            ].filter(Boolean).join(', ');

            if (calEvent.locations.length > 1 && calEvent.isgroupteaching === '1' && Object.hasOwn(calEvent.attendees, location.forgroup)) {
                location_title += ' (' + calEvent.attendees[location.forgroup].a_name + ')'; // Include the Group Name
            }

            if (location.postcode) {
                locations += '<li><a href="http://map.google.co.uk/maps?q=' + location.postcode.replaceAll(' ', '+') + '"><i class="' + FontAwesome.prefix('solid', 'location-dot') + '"></i>' + location_title + '</a></li>';
            } else {
                locations += '<li><i class="' + FontAwesome.prefix('solid', 'location-dot') + '"></i>' + location_title + '</li>';
            }
        });
    } else {
        locations = '<li><i class="' + FontAwesome.prefix('solid', 'location-dot') + '"></i><em>Location Information Unavailable</em></li>';
    }
    $('#modal-event-location').html('<ul class="padded-list">' + locations + '</ul>');

    $('#modal-event-overflow-location').empty();
    if (calEvent.overflow_id) {
        var overflow_location_title = calEvent.overflow_room + ', ' + calEvent.overflow_building;
        if (calEvent.overflow_postcode) {
            overflow_location += '<li><a href="http://map.google.co.uk/maps?q=' + calEvent.overflow_postcode.replaceAll(' ', '+') + '"><i class="' + FontAwesome.prefix('solid', 'location-arrow') + '"></i>' + overflow_location_title + ' (Overflow Location)</a></li>';
        } else {
            overflow_location += '<li><i class="' + FontAwesome.prefix('solid', 'location-arrow') + '"></i>' + calEvent.overflow_room + ' (Overflow Location)</li>';
        }
        $('#modal-event-overflow-location').html('<ul class="padded-list">' + overflow_location + '</ul>');
    }

    // Tutors
    if (calEvent.tutors && calEvent.tutors.length > 0) {
        // Sort tutors by lead lecturer first
        calEvent.tutors.sort(function (a, b) {
            return b.leadlecturer - a.leadlecturer;
        });

        $.each(calEvent.tutors, function (idx, lecturer) {
            if (lecturer.title !== null && lecturer.firstname !== null && lecturer.lastname !== null) {
                var leadLecturer = lecturer.leadlecturer === '1' ? ' (Lead Lecturer)' : '';
                lecturers += '<li><a href="mailto:' + lecturer.email + '"><i class="' + FontAwesome.prefix('solid', 'mortar-board') + '"></i>' + lecturer.title + ' ' + lecturer.firstname.substring(0, 1) + '. ' + lecturer.lastname + leadLecturer + '</a></li>';
            }
        });
    } else {
        lecturers = '<li><i class="' + FontAwesome.prefix('solid', 'mortar-board') + '"></i><em>Lecturer Information Unavailable</em></li>';
    }
    $('#modal-event-lecturer').html('<ul class="' + (calEvent.tutors.length > 0 ? 'padded-links' : 'padded-list') + '">' + lecturers + '</ul>');

    // Check if we span days
    const eventStart = dayjs.unix(calEvent.start).tz('Europe/London');
    const eventEnd   = dayjs.unix(calEvent.end).tz('Europe/London');
    const clockIcon  = '<i class="' + FontAwesome.prefix('regular', 'clock') + '"></i>';
    let timeHTML     = '';

    if (calEvent.end - calEvent.start < 86400) {
        timeHTML = clockIcon + eventStart.format(TIME) + ' - ' + eventEnd.format(TIME) + '  ' + eventStart.format('dddd ' + LONGDATE);
    } else {
        timeHTML = clockIcon + eventStart.format(TIME + ' ' + LONGDATE) + ' - ' + eventEnd.format(TIME + ' ' + LONGDATE);
    }

    $('#modal-event-times').html('<ul class="padded-list"><li>' + timeHTML + '</li></ul>');

    // Categories/Tags
    if (calEvent.tags) {
        // Remove the attendance qr code link from the staff tools list
        $('#tabs-stafftools ul li.attendance-qr-code-link').remove();

        $.each(calEvent.tags, function (idx, tag) {
            tags += '<li><a href="timetable/categories/' + tag.tagid + '"><i class="' + FontAwesome.prefix('solid', 'tags') + '"></i>' + tag.tagname + '</li>';
            // Check for tag for student self recording attendance via qr code and add link
            if (tag.tagid === '123') {
                $('li.class-tool-links').before('<li class="attendance-qr-code-link"><a href="#" id="btnStaffActionAttendanceQRcode" target="_blank"><i class="' + FontAwesome.prefix('solid', 'qrcode') + '" ></i>Attendance QR Code</a></li>');
            }
        });
        $('#modal-event-tag').html('<ul class="padded-list"><li class="heading">Categories</li>' + tags + '</ul>');
    }

    // Description
    $('#event-description').html('<ul class="padded-list"><li class="heading">Description</li><li>' + (calEvent.description ? calEvent.description : '<em>No description available</em>') + '</li></ul>');

    // Equipment
    $('#event-equipment').html(calEvent.equipment ? '<ul class="padded-list"><li class="heading">Equipment</li><li>' + calEvent.equipment + '</li></ul>' : '');

    var localoutcomes = '';
    var tomdocoutcomes = '';

    // Learning Outcomes
    if (calEvent.outcomes.local.length > 0) {
        $.each(calEvent.outcomes.local, function (idx, outcome) {
            localoutcomes += '<li>' + outcome + '</li>';
        });

        var html = '<ul class="padded-list"><li class="heading">University of Aberdeen</li>' + localoutcomes + '</ul>';

        // Add tomorrow docs if we have any
        if (calEvent.outcomes.tomdoc.length > 0) {
            $.each(calEvent.outcomes.tomdoc, function (idx, outcome) {
                tomdocoutcomes += '<li>' + outcome + '</li>';
            });
            html += '<ul class="padded-list"><li class="heading">Tomorrow\'s Doctors</li>' + tomdocoutcomes + '</ul>';
        }

        $('#tabs-outcomes').html(html);
    } else {
        $('#tabs-outcomes').html('<ul class="padded-list"><li><em>Please refer to your course handbook/workbook for learning outcomes.</em></ul></li>');
    }

    // Learning Resources
    var resources = '';
    var btnicon;
    var btntext;
    var iconext;
    if (calEvent.resources.length > 0) {
        // We have learning resources
        calEvent.resources.sort(function (a, b) {
            return a.position - b.position;
        });

        $.each(calEvent.resources, function (idx, resource) {
            if (resource.type === 'file') {
                btnicon = FontAwesome.prefix('solid', 'download');
                btntext = 'Download ' + File.getReadableExtension(resource.extension.replace('.', '')) + ' <span class="small text-dark">(' + File.getReadableFileSizeString(resource.size, 2) + ')</span>';
                iconext = File.getIcon(resource.extension);
            } else if (resource.type === 'link') {
                btnicon = FontAwesome.prefix('solid', 'link');
                btntext = 'Go to ' + resource.name;
                iconext = FontAwesome.prefix('solid', 'link');
            } else if (resource.type === 'recording') {
                btnicon = FontAwesome.prefix('solid', 'video-camera');
                btntext = 'Go to ' + resource.name;
                iconext = FontAwesome.prefix('solid', 'video-camera');
            }

            resources += '<li class="' + ($('.has-basic-role').length ? '' : 'sortable-position') + '" data-event-resource="' + resource.evresourceid + '" data-position="' + resource.position + '">';
            resources +=    '<p>';
            resources +=        '<strong><i class="' + iconext + '"></i>' + resource.name + '</strong><br>';
            // Display the filename and uses Array.prototype.split and Array.prototype.join() to remove the file hash
            resources +=        '<em class="small text-dark">' + resource.uri.split('_').slice(1).join('_') + '<br>';
            resources +=        '<br>';
            resources +=        'Uploaded: ' + dayjs.unix(resource.lastmodifieddate).format(LONGDATE) + ' by ' + resource.firstname + ' ' + resource.lastname + '</em>';
            resources +=    '</p>';
            if (resource.description) {
                resources +=    '<p><em>' + resource.description + '</em></p>';
            }
            resources +=    '<p><a href="' + base_url + 'pages/resource/' + resource.id + '" class="btn btn-sm btn-default" role="button"><i class="' + btnicon + '"></i>' + btntext + '</a></p>';
            resources += '</li>';
        });
    } else {
        resources = '<li><em>' + calEvent.resourceavailability + '</em></li>';
    }

    $('#tabs-resources').html('<div><ul class="padded-list" id="sortable">' + resources + '</ul></div>');

    if ($('.has-basic-role').length === 0) {
        $('#sortable').sortable({
            containment: 'parent',
            scroll: true,
            update: function (event, ui) {
                $(this).children().each(function (index) {
                    // Strict comparison cannot be used in the check below
                    if ($(this).attr('data-position') != index + 1) {
                        $(this).attr('data-position', index + 1).addClass('updated');
                    }
                });

                saveNewPositions();
            },
        });
    }

    // Add the button actions
    $('#btnStaffActionResources').attr('href', base_url + 'resources/manager/' + calEvent.id);
    $('#btnStaffActionOutcomes').attr('href', base_url + 'outcomes/manager/' + calEvent.id);
    $('#btnStaffActionAttendanceRegister').attr('href', base_url + 'attendances/register/' + calEvent.id);
    $('#btnStaffActionAttendanceQRcode').attr('href', base_url + 'attendances/generateQrCode/' + calEvent.id);
    $('#btnStaffActionComms').attr('href', base_url + 'timetable/staffaction/comms/' + calEvent.id);
    $('#btnStaffActionRegister').attr('href', base_url + 'registers/classlist/' + calEvent.id);
    $('#btnStaffActionCombinedRegister').attr('href', base_url + 'registers/classlist/' + calEvent.id + '/true');
    $('#btnStaffActionPhotoboard').attr('href', base_url + 'registers/photoboard/' + calEvent.id);

    // Show the modal
    $('#eventdetails').modal('show');
}

/**
 * Function for ajax call to update event resource positions
 *
 * @return void
 */
function saveNewPositions() {
    var positions = [];
    $('.updated').each(function () {
        positions.push([$(this).attr('data-event-resource'), $(this).attr('data-position')]);
        $(this).removeClass('updated');
    });

    $.ajax({
        url: base_url + 'timetable/ajax_positions',
        type: 'get',
        dataType: 'json',
        data: {
            postionsData: positions,
        },
    });
}
